import {Component, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';
import {UsuarioService} from '@servicios/Usuario.service';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {RecuperarPasswordComponent} from './RecuperarPassword/RecuperarPassword.component';

import {environment} from '../../../environments/environment';
@Component(
    {
        selector: 'laddiPage',
        templateUrl: './LaddingPage.template.html',
        styleUrls: ['./LaddingPage.scss'],
    })

export class LaddingPageComponent {
    @ViewChild('recuperarPassword') recuperarPassword!: RecuperarPasswordComponent;

    public login: {Cuenta: string, Id: string, Password: string, errorActivo?: boolean};
    public errorActivo: boolean;
    public verRecuperarPassword: boolean = true;
    public verPassword: boolean = true;
    
    logo: string;

    constructor(private appService: AppService, private router: Router, public sistemaService: SistemaService, private mensajeService: MensajeService, public translate: TranslateService, public usuarioService: UsuarioService) {
        this.errorActivo = false;
        //this.verRecuperarPassword = this.sistemaService.GetValorParametro("RecuperarPassword") === "1" ? true : false;
        this.login = {Cuenta: "", Id: "", Password: ""};
        
        this.logo = environment.logo + "logo.png";
    }

    ngOnInit() {
    }

    IniciarSesion() {
        if (!this.usuarioService.logeando) {
            this.errorActivo = true;

            if (this.ValidarDatosLogin()) {
                let pass = this.appService.EncriptarDatos({Password: this.login.Password});
                var datos = {Cuenta: this.login.Cuenta, Id: this.login.Id, Password: pass, Idioma: ""};
                this.appService.Post("auth/login", datos).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.usuarioService.logeando = true;
                        localStorage.setItem(this.sistemaService.localStoreVariable.JWT, res.data.token);
                        localStorage.setItem(this.sistemaService.localStoreVariable.AOT, res.data.AOT);
                        this.router.navigateByUrl('/app/home');
                    } else {
                        this.usuarioService.logeando = false;
                    }
                }).catch(err => {
                    this.usuarioService.logeando = false;
                })

            }
            else {
                this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant("ErrorDatosIncompletos"));
            }
        }
    }

    ValidarDatosLogin() {
        if (!this.login.Cuenta) {
            return false;
        }
        if (!this.login.Id) {
            return false;
        }
        if (!this.login.Password) {
            return false;
        }

        return true;
    }

    DatosInvalidos() {

    }

    RecuperarPassword() {
        this.recuperarPassword.Abrir(this.login.Cuenta);
    }

    CambiarVerPassword() {
        this.verPassword = !this.verPassword;
    }
}
